const initExampleSections = () => {
    [...document.querySelectorAll('.example-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initExampleSection(item));
};

const initExampleSection = (section) => {
    section.dataset.init = true;
};

export { initExampleSections };